import api from '@/api/axiosApi'
import type { ChangeLogResponse } from '@/types'

export async function fetchAuditTrail(
  planId: string,
  versionId: string,
  page: number = 1,
  pageSize: number = 20
): Promise<ChangeLogResponse> {
  const offset = (page - 1) * pageSize
  const response = await api.get<ChangeLogResponse>(
    `/plans/${planId}/versions/${versionId}/audit-trail`,
    { params: { offset, limit: pageSize } }
  )
  return response.data
}
